import { Validator } from 'vee-validate';
import elEn from 'element-ui/lib/locale/lang/en';
import elEs from 'element-ui/lib/locale/lang/es';
import elLocale from 'element-ui/lib/locale';
import elPt from 'element-ui/lib/locale/lang/pt-br';
import en from 'vee-validate/dist/locale/en';
import es from 'vee-validate/dist/locale/es';
import i18n from 'src/i18n';
import ptBR from 'vee-validate/dist/locale/pt_BR';
import SweetAlert from 'src/class/Alerts';

// const DISK_URL = 'http://localhost:8000/';
const DISK_URL = 'https://app.smartcultivo.com/smart-backend/';
// const DISK_URL = "https://demo.smartcultivo.com/smart-backend/";

// const BASE_URL = "http://localhost:8080/";
const BASE_URL = 'https://app.smartcultivo.com/';
// const BASE_URL = "https://demo.smartcultivo.com/";

// const AXIOS_URL = "http://localhost:8000/api";
const AXIOS_URL = 'https://app.smartcultivo.com/smart-backend/api';
// const AXIOS_URL = "https://demo.smartcultivo.com/smart-backend/api";

// const LINK_MAPS = "http://localhost:8000/mapas/";
const LINK_MAPS = 'https://app.smartcultivo.com/smart-backend/mapas/';
// const LINK_MAPS = "https://demo.smartcultivo.com/smart-backend/mapas/";

/**
 * Método para generar la alerta, si queremos continuar con el proceso de
 * creación o edición en los paso a paso, si la opción es continuar, la función
 * genera un salto al primer paso y reiniciará las validaciones en cada uno
 * de los pasos, esto se hará llamando a los métodos en su createOrEdit y
 * limpiará la storage con la información del formulario; por el contrario,
 * si la opción es salir, este redireccionará a la ruta pasada por parámetro
 * @param {*} scope
 * @param {String} message
 * @param {String} routePush
 * @param {String} model
 * @param {Boolean} isWizard
 * @returns
 */
async function showContinue(scope, message, routePush, model, isWizard = true) {
  return SweetAlert.continue(message).then((result) => {
    if (result.value) {
      try {
        scope.$validator.reset();
      } catch (error) { }

      if (model) {
        eval('scope.' + model + ' = {}');
      }

      if (isWizard) {
        try {
          scope.goToFirstStep();
        } catch (error) {
          try {
            scope.$refs.formWizard.reset();
          } catch (error) {
            try {
              scope.$refs.formWizard.$refs.wizard[0].reset();
            } catch (error) {
              try {
                scope.$refs.formWizard.$refs.wizard.reset();
              } catch (error) { }
            }
          }
        }

        scope.cleanAllSteps();
      }

      sessionStorage.removeItem('editForm');
    } else if (result.dismiss) {
      scope.$router.push(routePush);
    }

    return result;
  });
}

/**
 * Resetear las propiedades de un objeto y el objeto en si
 * a sus valores por default o iniciales, con excepción de algunos
 * en ciertos casos
 * @param {*} obj
 * @param {Array} excludes
 * @returns
 */
function resetObjectProperties(obj, excludes = []) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !excludes.includes(String(key))) {
      const property = obj[key];

      if (typeof property === 'object' && property !== null) {
        if (Array.isArray(property)) {
          obj[key] = [];
        } else {
          resetObjectProperties(property);
        }
      } else {
        obj[key] = null;
      }
    }
  }

  return obj;
}

/**
 * Obtener las propiedades únicas del objeto pasado por parámetro
 * @param {*} object
 * @param {*} keyToValidateUnique
 * @returns
 */
function objectsUnique(object, keyToValidateUnique) {
  const array = object;
  const arrayUniqueByKey = [
    ...new Map(array.map((item) => [item[keyToValidateUnique], item])).values(),
  ];

  return arrayUniqueByKey;
}

/**
 * Construir un array basado en rango inicial y final
 * @param {Number} start
 * @param {Number} end
 * @returns
 */
function range(start, end) {
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx);
}

/**
 * Método para crear el árbol de permisos y visualizar
 * @param {*} newVal
 * @param {Array} specificPermissionsInitial
 * @returns
 */
function assembleTreePermission(newVal, specificPermissionsInitial) {
  let specificPermissions = [];
  try {
    let specificPermissionsFiltered = specificPermissionsInitial.map(
      (specific_permission) => {
        return specific_permission.children.filter((child) => {
          return newVal.includes(parseInt(child.identifier));
        });
      }
    );

    if (specificPermissionsFiltered[0].length === 0) {
      specificPermissions = [];
    } else {
      specificPermissions = [
        {
          label: i18n.t('common_words.all'),
          id: 0,
          children: specificPermissionsFiltered[0],
        },
      ];
    }
  } catch (error) {
    specificPermissions = JSON.parse(
      JSON.stringify(specificPermissionsInitial)
    );
  }

  return specificPermissions;
}

/**
 * Obtener los valores repetidos de un array por parámetro
 * @param {Array} data
 * @returns
 */
function getRepeatsFromArray(data) {
  let repeats = [];
  let temp = [];

  data.forEach((value, index) => {
    temp = Object.assign([], data);
    temp.splice(index, 1);
    if (temp.indexOf(value) != -1 && repeats.indexOf(value) == -1)
      repeats.push(value);
  });

  return repeats;
}

/**
 * Obtener la suma de los valores de un array
 * por parámetro
 * @param {Array} arrayData
 * @returns
 */
function getSumOfValorFromArray(arrayData) {
  const total = arrayData.reduce((prev, curr) => {
    const value = Number(curr);
    if (!isNaN(value)) {
      return Number(prev) + value;
    } else {
      return Number(prev);
    }
  }, 0);

  return total;
}

/**
 * Validar si una variable existe, no esta vacia y es
 * diferente de null
 * @param {*} data
 * @returns
 */
function isset(data) {
  let validate = data && data !== null;

  if (data && typeof data === 'string') {
    validate =
      validate &&
      data !== '' &&
      String(data) !== '' &&
      String(data).trim() !== '';
  }

  if (data && Array.isArray(data)) {
    validate = validate && data.length > 0;
  }

  if (typeof data === 'number') {
    validate = !isNaN(data);
  }

  return validate;
}

/**
 * Validar si una variable existe, no esta vacia
 * diferente de null y es un numero decimal o entero
 * @param {Number} data
 * @returns
 */
function ifExistNumber(data) {
  let validate = data && data !== null;
  if (typeof data === 'number') {
    validate =
      (!Number.isInteger(data) && !isNaN(data)) ||
      (Number.isInteger(data) && !isNaN(data));
  }

  return validate;
}

/**
 * Borrar de la localStorage todas las llaves guardadas,
 * a excepción de la variable pasada por parámetro
 * si esta es enviada con valor diferente a null
 * @param {*} except
 */
const removeLocalStorage = (except = null) => {
  if (!except) localStorage.clear();
  else {
    const keysStorage = Object.keys(localStorage);

    keysStorage.forEach((key) => {
      if (key !== except) {
        localStorage.removeItem(key);
      }
    });
  }
};

/**
 * Método para setear en el validator el idioma en ejecución
 */
const setLocalizeLanguage = () => {
  switch (i18n.locale) {
    case 'pt_BR':
      Validator.localize(i18n.locale, ptBR);
      break;
    case 'en':
      Validator.localize(i18n.locale, en);
      break;
    default:
      Validator.localize(i18n.locale, es);
      break;
  }
};

/**
 * Método para setear en el validator el idioma en ejecución
 */
const setLocalizeElementUI = () => {
  switch (i18n.locale) {
    case 'pt_BR':
      elLocale.use(elPt);
      break;
    case 'en':
      elLocale.use(elEn);
      break;
    default:
      elLocale.use(elEs);
      break;
  }

  return elLocale;
};

/**
 * Método para obtener el SRC de una imagen con respecto al disco
 * @param {String} url
 * @param {String} disk
 * @returns
 */
function getSrcFromImage(url, disk) {
  if (!url) return null;

  return url.includes('http') ? url : `${DISK_URL}path_images/${disk}/${url}`;
}

function getCenterCost(detail) {
  let result = [];
  if (detail.labor_header) {
    result = detail.labor_header.farm.businesses.filter(
      (business) => business.id !== 1
    );
  }

  let codeBusiness = '';
  if (result && result.length > 0) {
    codeBusiness = result[0].cost_center ? result[0].cost_center : '';
  }

  const farmCode = detail.labor_header
    ? detail.labor_header.farm.cost_center
    : '';
  const activityCode = detail.activity.cost_center
    ? detail.activity.cost_center
    : '';

  return `${codeBusiness}${farmCode}${activityCode}`;
}

function autoSelectElements(type, dataElements) {
  if (dataElements.length == 1) {
    switch (Number(type)) {
      case 0:
        return dataElements[0].id;
      default:
        return [dataElements[0].id];
    }
  }

  return Number(type) === 1 ? [] : null;
}

function capitalizeString(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function getUrlMasterModule() {
  const currentModule = sessionStorage.getItem('urlModule').substring(1);
  return currentModule.split('/')[0];
}

function getDateToday() {
  const today = new Date();
  const formattedDate = today.toISOString().slice(2, 10);
  return formattedDate;
}

/**
 * Método que dadas la fechas seleccionada dentro del FilterComponent, el tipo 
 * de tiempo seleccionado y los años limite te retorna true o false si el rango
 * seleccionado de tiempo esta dentro de los años de consulta permitidos
 * @param {String} datei
 * @param {String} datef
 * @param {String} bySel
 * @param {Int} limitYears
 * @returns {Boolean}
 */
function validateDateRangeByFilterComponentByYear(datei, datef, bySel, limitYears) {
  let startYear, endYear;

  switch (bySel) {
    case 'Día':
    case 'Mes':
    case 'Año':
      startYear = new Date(datei).getFullYear();
      endYear = new Date(datef).getFullYear();
      break;

    case 'Semana':
      startYear = parseInt(datei.split('-')[0], 10);
      endYear = parseInt(datef.split('-')[0], 10);
      break;

    default:
      return false;
  }

  const diff = endYear - startYear;
  if (diff > limitYears) return false;

  return true;
}

/**
 * Método para conviertir la primera letra de cada palabra a mayúscula y las demás letras en minúsculas
 * @param {String} str
 * @returns
 */
function convertFirstLetterUppercase(str) {

  if (!str) return '';

  return str
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Método que cacula la fecha en que comienza el año y termina en formto YYYY-MM-DD
 * @returns {Object} datei = fecha inicial. datef=fecha final
 */
function getYearRange() {
  const now = new Date();
  const year = now.getFullYear();

  const startDate = new Date(year, 0, 1);  // Enero = 0
  const endDate = new Date(year, 11, 31);  // Diciembre = 11

  const format = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  return {
    datei: format(startDate),
    datef: format(endDate),
  };
}

export {
  assembleTreePermission,
  getRepeatsFromArray,
  getSrcFromImage,
  getSumOfValorFromArray,
  getCenterCost,
  isset,
  objectsUnique,
  range,
  removeLocalStorage,
  resetObjectProperties,
  setLocalizeElementUI,
  setLocalizeLanguage,
  showContinue,
  autoSelectElements,
  capitalizeString,
  convertFirstLetterUppercase,
  ifExistNumber,
  getUrlMasterModule,
  getDateToday,
  validateDateRangeByFilterComponentByYear,
  getYearRange,
  AXIOS_URL,
  BASE_URL,
  DISK_URL,
  LINK_MAPS,
};
